import React from "react";

export const Cancri = () => {
  return (
    <div>
      <div
        id={"cancri"}
        style={{
          frameborder: "0",
          width: "100%",
          height: "470px",
        }}
      ></div>
    </div>
  );
};

